import { FC } from 'react'
import styles from './Pod4SeamlessSnoring.module.scss'
import { Pod4SeamlessSnoringProps } from './types'
import { Img } from 'components/basic/Img'
import { SnoreCard } from '../Phantom/SnoreCard'
import cx from 'classnames'

export const Pod4SeamlessSnoring: FC<Pod4SeamlessSnoringProps> = (props) => {
	const {} = props
	return (
		<div className={styles.container}>
			<div className={styles.section}>
				<div className={styles.headerSection}>
					<div className={styles.pill}>New</div>
					<div>
						<div className={styles.title}>See how much you snore each night</div>
					</div>
					<div className={cx(styles.description, styles.descriptionTop)}>
						Pod 4 detects and tracks snoring for up to two people at once. Rather than using a microphone to detect sound, the Pod tracks vibration patterns through sensors.
					</div>
				</div>

				<div className={styles.image_container}>
					<Img
						className={styles.snoreImg}
						alt=""
						sources={[
							{
								src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/seamles_snoring_top_mob_2904.png',
								mediaQuery: '(max-width: 599px)',
								dprHeight: 1080,
							},
							{
								src: 'https://eightsleep.imgix.net/assets/seamless_snoreing_top_29042024.png',
								mediaQuery: '(min-width: 600px)',
								dprHeight: 1080,
							},
						]}
						src="https://eightsleep.imgix.net/assets/seamless_snoreing_top_29042024.png"
					/>
					<div className={styles.snoreCard}>
						<SnoreCard />
					</div>
				</div>
			</div>
			<div className={styles.section}>
				<div className={styles.headerSection}>
					<div className={styles.pill}>New</div>
					<div>
						<div className={styles.title}>Stop snoring, automatically</div>
					</div>
					<div className={styles.description}>The Base of Pod 4 Ultra automatically elevates the head area to reduce or stop snoring episodes.</div>
				</div>
				<Img
					className={styles.snoreImg}
					alt=""
					sources={[
						{
							src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2_mobile.jpg',
							mediaQuery: '(max-width: 599px)',
							dprHeight: 1080,
						},
						{
							src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2.jpg',
							mediaQuery: '(min-width: 600px)',
							dprHeight: 1080,
						},
					]}
					src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2.jpg"
				/>
			</div>
			<div className={styles.section}>
				<div className={styles.bigText}>
					<strong>Autopilot</strong> has been clinically proven to reduce snoring by up to 45%<span className={styles.asterisk}>*</span>
				</div>
			</div>
		</div>
	)
}
